export default __webpack_public_path__ + "media/images/gallery/bootstrap-material-ui-kit-732ce3e72177ff91e36bae0e91d69d99.jpg";